module.exports = __webpack_public_path__ + "img/1.bfe83b3d.png";